module.exports = __webpack_public_path__ + "img/loadingIcon.c04d80cb.png";